var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),_c('Menu'),_c('h3',[_vm._v("LES SITUATIONS DE COMMUNICATION")]),_c('ContexCant'),_c('ContexConstruction'),_c('ContexSocial'),_c('NextPrevBtn',{attrs:{"nxtprev-list":_vm.nxtprevDefContex}}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }